import React from 'react';
import {
    FaArrowRight,
    FaCircle,
    FaCrop, FaLinesLeaning, FaRotate,
    FaSquare,
    FaT, FaTextHeight
} from "react-icons/fa6";
import ToolbarDropdownBtn from "./toolbar-dropdown-btn.jsx";
import DrawAction from "../enums/draw-action.js";
import ToolbarColorBtn from "./toolbar-color-btn.jsx";
import {FaTrash} from "react-icons/fa";

const ImageEditorToolbar = ({reload, onSelectAction, activeAction, handleCrop, isCropping, handleStrokeSize, handleFontSize, handleStrokeColor, fontSize, strokeColor, strokeSize, currentShape, removeShape}) => {

    const drawButtons = [
        {type: DrawAction.RECTANGLE, icon: FaSquare, tooltip: "Retângulo"},
        {type: DrawAction.CIRCLE, icon: FaCircle, tooltip: "Círculo"},
        {type: DrawAction.ARROW, icon: FaArrowRight, tooltip: "Seta"},
        {type: DrawAction.ARROW_RED, icon: FaArrowRight, color: "#D32F2F", tooltip: "Seta vermelha (Suspeito)"},
        {type: DrawAction.ARROW_BLUE, icon: FaArrowRight, color: "#1976D2", tooltip: "Seta azul (Vítima)"},
        {type: DrawAction.TEXT, icon: FaT, tooltip: "Texto"},
    ]

    return (
        <div className={"flex items-center justify-center p-2 gap-1 canvas-toolbar-container"}>
            <button className="image-editor-button" disabled={isCropping} onClick={reload} title={"Resetar"}>
                <FaRotate className="image-editor-button-icon" />
            </button>

            {
                drawButtons.map(btn => {
                    const isActive = activeAction === btn.type;
                    const Icon = btn.icon;

                    return (
                        <button
                            key={btn.type}
                            className={"image-editor-button" + (isActive ? " active" : "")}
                            onClick={() => onSelectAction(btn.type)}
                            disabled={isCropping}
                            title={btn.tooltip}
                        >
                            <Icon className="image-editor-button-icon" style={{color: btn?.color ?? "rgba(36, 39, 46, 0.78)"}}/>
                        </button>
                    )
                })
            }
            <ToolbarDropdownBtn id={"stroke"} title={"Espessura"} values={[4, 8, 16, 32, 64, 72]} selected={strokeSize} onChange={handleStrokeSize} disabled={isCropping}>
                <FaLinesLeaning className="image-editor-button-icon"/>
            </ToolbarDropdownBtn>

            <ToolbarDropdownBtn id={"font"} title={"Fonte"} values={[14, 18, 24, 36, 48, 60, 72]} selected={fontSize} onChange={handleFontSize} disabled={isCropping}>
                <FaTextHeight className="image-editor-button-icon"/>
            </ToolbarDropdownBtn>

            <ToolbarColorBtn onChange={handleStrokeColor} strokeColor={strokeColor} disabled={isCropping}/>

            <button className={"image-editor-button" + (isCropping ? " active" : "")} onClick={handleCrop} title={"Cortar"}>
                <FaCrop className="image-editor-button-icon" />
            </button>

            <button className={"image-editor-button" + (isCropping ? " active" : "")} onClick={removeShape} disabled={!currentShape} title={"Deletar"}>
                <FaTrash className="image-editor-button-icon" />
            </button>
        </div>
    );
};

export default ImageEditorToolbar;